<script setup lang="ts">
import type { DisciplineStageComment } from '../model/interfaces'

import { faPlus } from '@fortawesome/pro-regular-svg-icons'

import { AppMultiSelect, AppSelect } from '@shared/ui/selects'
import { AppIcon } from '@shared/ui/icons'
import { AppTextarea } from '@shared/ui/fields'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useDisciplineCommentForm } from '../model/discipline-comment-form.hook'

defineOptions({
  name: 'DisciplineCommentForm',
})

const props = withDefaults(defineProps<{
  comment?: DisciplineStageComment | null
}>(), {
  comment: null,
})

const emit = defineEmits<{
  'success:save': [DisciplineStageComment]
  'click:cancel': []
}>()

const {
  refShowForm,
  refForm,
  refChannel,
  refReach,
  refReachState,
  refIsDisabled,
  refIsSaving,
  label,
  isEditing,
  channelOptions,
  reachOptions,
  showForm,
  setComment,
  cancel,
  submit,
} = useDisciplineCommentForm({
  comment: props.comment,
  onSaved: (comment: DisciplineStageComment) => emit('success:save', comment),
  onCancel: () => emit('click:cancel'),
})
</script>

<template>
  <div class="discipline-comment-form">
    <div
      v-if="refShowForm"
      class="discipline-comment-form__general"
    >
      <AppTextarea
        :label="label"
        :value="refForm.comment"
        placeholder="Type here"
        @input="setComment"
      />
      <div class="discipline-comment-form__rows">
        <AppMultiSelect
          v-model="refChannel"
          label="Channel:"
          placeholder="Select here"
          :options="channelOptions"
          :disabled="refIsSaving"
          clearable
        />
        <AppSelect
          v-model="refReach"
          label="Reach:"
          placeholder="Select here"
          :options="reachOptions"
          :state="refReachState"
          :disabled="refIsSaving"
        />
      </div>
      <div class="discipline-comment-form__controls">
        <BtnPrimary
          :text="label"
          :disabled="refIsDisabled"
          @click="submit"
        />
        <BtnSecondary
          text="Cancel"
          :disabled="refIsSaving"
          @click="cancel"
        />
      </div>
    </div>
    <div
      v-else
      class="discipline-comment-form__btn"
    >
      <BtnPrimary
        :text="label"
        element-width="full"
        @click="showForm"
      >
        <template
          v-if="!isEditing"
          #iconLeft
        >
          <AppIcon :icon="faPlus" />
        </template>
      </BtnPrimary>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineCommentForm.scss" />
